




















































































import { Component, Vue } from 'vue-property-decorator'
import Header from '@/components/Header.vue'
import Indicator from '@/views/reservation/molecules/Indicator.vue'
import ReturnTopButton from '@/views/reservation/atoms/ReturnTopButton.vue'
import { getServiceName, getURL } from '@/utils/app-setting'

@Component({
  name: 'ReservationComplate',
  components: {
    Header,
    Indicator,
    ReturnTopButton
  }
})
export default class extends Vue {
  public serviceName = getServiceName()
  public url = getURL()
}
